module.exports = __webpack_public_path__ + "img/interpolice_logo_complet.7693f545.svg";